<template>
  <window :window-id="windowId">
    <window-tab :title="windowTitle">
      <div class="form-group form-row" v-if="datasetId">
        <label :for="safeId('fileName')" class="col-sm-4 col-form-label">URL</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('fileName')" v-model.lazy="fileName">
        </div>
      </div>
      <div class="form-group form-row">
        <div class="col-sm-8 offset-4">
          <button type="button" class="btn btn-block btn-primary" @click="fetch()">Fetch</button>
        </div>
      </div>
      <div class="form-group form-row" v-if="datasetId">
        <label :for="safeId('refetchSecs')" class="col-sm-8 col-form-label">Automatic refresh (seconds)</label>
        <div class="col-sm-4">
          <input type="number" class="form-control" :id="safeId('refetchSecs')" v-model.lazy="refetchSecs">
        </div>
      </div>
      <div class="alert alert-danger" v-if="errorMessage">
        <p><b>Error:</b> {{ errorMessage }}</p>
      </div>

      <dataset-table :dataset-id="datasetId"></dataset-table>
    </window-tab>
    <window-tab title="Settings" icon="cog">
      <dataset-settings :window-id="windowId" :dataset-id="datasetId"></dataset-settings>
    </window-tab>
  </window>
</template>

<script>
  import { uuid } from '../lib'
  import { windowPropsMixin } from '../mixins'
  import * as mutation from '../store/mutation-types'
  import DatasetSettings from './dataset-settings.vue'
  import DatasetTable from './dataset-table.vue'

  let optionMergeRecords = false

  export default {
    name: 'race-result-dataset',
    components: {DatasetSettings, DatasetTable},
    mixins: [windowPropsMixin],
    data () {
      return {
        errorMessage: null,
        refetchSecs: 0,
        timeoutId: null
      }
    },
    computed: {
      datasetId () {
        return this.$store.getters.windowData(this.windowId).contentId
      },
      dataset () {
        return this.$store.getters.dataset(this.datasetId) || {}
      },
      title () {
        return this.dataset.title || 'Unnamed dataset'
      },
      fileName: {
        get () {
          return this.dataset.fileName || ''
        },
        set (val) {
          this.$store.commit(mutation.DATASET_UPDATE_META, {
            datasetId: this.datasetId,
            fileName: val,
            emit: true
          })
        }
      }
    },
    mounted () {
      if (this.fileName && (this.dataset.records || []).length === 0) {
        this.fetch()
      }
    },
    methods: {
      fetch () {
        console.log('[race-result/dataset] fetching data')
        this.errorMessage = null
        const request = new XMLHttpRequest()
        request.open('GET', this.fileName, true)
        request.onload = function (event) {
          if (!event.target) {
            this.errorMessage = 'Unknown error'
            return
          }

          if (event.target.status !== 200) {
            this.errorMessage = event.target.statusText
            return
          }
          const response = JSON.parse(event.target.response)

          const fields = response.list.Fields.map(field => field.Label.toLowerCase())

          const rows = response.data.map((arr, rowIdx) => {
            const result = arr.slice(1, arr.length).reduce((row, val, idx) => {
              if (fields.length > idx) {
                row[fields[idx]] = val
              }
              return row
            }, {})
            result['sortorder'] = rowIdx + 1
            return result
          })

          const columnMap = {
            'sortorder': 'SORT_ORDER',
            'firstname': 'FIRST NAME',
            'lastname': 'LAST NAME',
            'bibnumber': 'BIB',
            'country': 'COUNTRY',
            'club': 'CLUB',
            'rank': 'RANK',
            'gap': 'SCORE',
            'tp.name': 'SPLIT'
          }

          const records = this.mergeRecords(rows, columnMap)
          const columns = Object.values(columnMap)

          this.$store.commit(mutation.DATASET_UPDATE_RECORDS, {
            datasetId: this.datasetId,
            columns: columns,
            records: records.map(record => {
              record.recordId = record.recordId || uuid()
              return record
            }),
            emit: true
          })

          // Set timeout to refresh data
          this.setTimeout()
        }.bind(this)
        request.onerror = function (event) {
          console.log('Error:', event)
          this.errorMessage = JSON.stringify(event)
        }.bind(this)
        request.send()
      },
      setTimeout () {
        this.clearTimeout()
        if (this.refetchSecs > 0) {
          this.timeoutId = window.setTimeout(this.fetch.bind(this), this.refetchSecs * 1000)
        }
      },
      clearTimeout () {
        if (this.timeoutId) {
          window.clearTimeout(this.timeoutId)
          this.timeoutId = null
        }
      },
      mergeRecords (rows, columnMap) {
        const records = this.dataset.records || []
        let maxLaps = 0
        const newRecords = rows.map((row, rowIdx) => {
          const record = {}
          Object.keys(columnMap).forEach(key => {
            if (key === 'gap') {
              if (rowIdx === 0) {
                record[columnMap[key]] = row['racetime']
                maxLaps = Number(row['laps'])
              } else {
                const diffLaps = Number(row['laps']) - maxLaps
                if (diffLaps) {
                  record[columnMap[key]] = diffLaps + 'R'
                } else {
                  record[columnMap[key]] = row[key]
                }
              }
            } else {
              record[columnMap[key]] = row[key]
            }
          })
          return record
        })
        if (optionMergeRecords) {
          newRecords.forEach(newRecord => {
            const oldRecord = records.find(r => r.BIB === newRecord.BIB)
            if (!oldRecord) {
              records.push(newRecord)
            } else {
              Object.keys(newRecord).forEach(key => {
                oldRecord[key] = newRecord[key] || oldRecord[key]
              })
            }
          })
          // records.sort((a, b) => a.SORT_ORDER - b.SORT_ORDER)
          return records
        }
        return newRecords
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/race-result-dataset.vue